import React, { Fragment, useContext } from "react";
import { Controller, FormProvider, useForm } from "react-hook-form";
import FormSection from "../../../../components/wrappers/FormSection";
import { Box, Button, Divider, FormControlLabel, Grid, Stack, Switch, TextField, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import InvertableStack from "../../../../components/wrappers/InvertableStack";
import AddUserToClinicFormBody from "../../../admin/clinic/form/AddUserToClinicFormBody";
import { zodResolver } from "@hookform/resolvers/zod";
import { createClinicResolver } from "../../../admin/clinic/form/utils/AddUserToClinicFunctions";
import { INPUT_FIELDS } from "./enums/ClinicInputFields";
import CountrySelector from "../../../../components/form/CountrySelector";
import { ToggleDrawerContext } from "../../../../contexts/ToggleDrawer";
import { CLINICS_MASTER } from "../../../../enums/QueryKeys";
import { parseClinic } from "./utils/CreateClinic";
import { CLINICS } from "../../../../enums/ApiPaths";
import useSubmit from "../../species/hooks/useSubmit";
import ConfirmAndCancelButtons from "../../../../components/buttons/ConfirmAndCancelButtons";

export default function AddClinicForm() {
  const { t } = useTranslation();
  const methods = useForm({ resolver: zodResolver(createClinicResolver(t)) });
  const [isOpen, setIsOpen] = useContext(ToggleDrawerContext);
  const submittion = useSubmit(null, CLINICS, CLINICS_MASTER);
  async function submitData(data) {
    const res = await submittion.submitCallback(parseClinic(data));

    if (res) {
      setIsOpen(false);
    }
  }

  return (
    <Fragment>
      <form onSubmit={methods.handleSubmit(submitData)}>
        <Stack spacing={3}>
          <FormSection title={t("ClinicInfo")}>
            <Grid container spacing={1}>
              {INPUT_FIELDS.map((textfield) => (
                <Grid key={textfield.register} item xs={12 / 2}>
                  <TextField
                    fullWidth
                    label={t(textfield.placeHolder)}
                    {...methods.register(`clinic.${textfield.register}`)}
                    error={
                      !!methods.formState.errors?.clinic?.[textfield.register]
                    }
                    helperText={
                      methods.formState.errors?.clinic?.[textfield.register]
                        ?.message
                    }
                  />
                </Grid>
              ))}
              <Grid item xs={12 / 2}>
                <FormProvider {...methods}>
                  <CountrySelector />
                </FormProvider>
              </Grid>
              <Grid item sm={6}>
                <Stack
                  border={"1px solid gray"}
                  p={1}
                  borderRadius={"5px"}
                  direction={"row"}
                  sx={{ width: "100%", height: "100%" }}
                  justifyContent={"space-between"}
                  alignItems={"center"}
                >
                  <Typography>{t("HideClinic")}</Typography>
                  <FormProvider {...methods}>
                    <Controller
                      name={"clinic.hidden"}
                      control={methods.control}
                      render={({ field }) => (
                        <FormControlLabel
                          control={
                            <Switch
                              defaultChecked
                              {...field}
                              {...methods.register("clinic.hidden")}
                            />
                          }
                        />
                      )}
                    />
                  </FormProvider>
                </Stack>
              </Grid>
            </Grid>
          </FormSection>
          <Divider />
          <FormSection title={t("")}>
            <InvertableStack>
              <AddUserToClinicFormBody
                errors={methods.formState.errors}
                register={methods.register}
              />
            </InvertableStack>
          </FormSection>
        </Stack>
        <Grid container>
          <Grid item xs={12}>
            <ConfirmAndCancelButtons
              confirmTitle="Save"
              cancelTitle="Cancel"
              onCancel={() => setIsOpen(false)}
              confirmButtonType="submit"
            />
          </Grid>
        </Grid>
      </form>
    </Fragment>
  );
}
